import MuiPaper from '@mui/material/Paper';
import React from 'react';
export const Paper = React.forwardRef((props,ref) => {
    const {themeType,...rest} = props;
    const paperComponent = (
        <MuiPaper {...rest} ref={ref} />
    );
    return paperComponent;
});
